// Supabase-klienten städar bort url-hashen när den försöker läsa in en
// session från en inloggningslänk. Vi fångar därför eventuellt fel direkt
// när appen startar (denna modul importeras först i src/router.tsx), så att
// inloggningssidan kan erbjuda en ny länk när länken redan är förbrukad
// eller har gått ut.
export type AuthUrlError = {
  code: string | null;
  message: string | null;
  email: string | null;
};

const STORAGE_KEY = "alkoholprovet:auth_link_error";

function read(): AuthUrlError | null {
  if (typeof window === "undefined") return null;
  const hash = new URLSearchParams(window.location.hash.replace(/^#/, ""));
  const query = new URLSearchParams(window.location.search);
  const code = hash.get("error_code") ?? query.get("error_code");
  const err = hash.get("error") ?? query.get("error");
  if (!code && !err) return null;
  return {
    code: code ?? err ?? null,
    message: hash.get("error_description") ?? query.get("error_description"),
    email: hash.get("email") ?? query.get("email"),
  };
}

let captured: AuthUrlError | null = read();

if (typeof window !== "undefined") {
  try {
    if (captured) {
      window.sessionStorage?.setItem(STORAGE_KEY, JSON.stringify(captured));
    } else {
      const stored = window.sessionStorage?.getItem(STORAGE_KEY);
      if (stored) captured = JSON.parse(stored) as AuthUrlError;
    }
  } catch {
    /* sessionStorage kan vara blockerad – felet visas ändå i samma vy */
  }
}

export function getAuthUrlError(): AuthUrlError | null {
  return captured;
}

/** Rensa felet när det har visats, så det inte dyker upp igen. */
export function clearAuthUrlError(): void {
  captured = null;
  try {
    window.sessionStorage?.removeItem(STORAGE_KEY);
  } catch {
    /* ignorera */
  }
}
